import { PersistedQueryParameterManager } from './PersistedQueryParameterManager';
import { QUERY_PARAMETER_MANAGER_STORAGE_KEY, SHOW_ABAD } from './constants';

export const QueryParamsManager = new PersistedQueryParameterManager(QUERY_PARAMETER_MANAGER_STORAGE_KEY, {
    alwaysRemove: [SHOW_ABAD],
});
